/**
 * Required validation
 *
 * @param {*} value
 *
 * @return {String}
 */
export default function required (value) {
    return value ? '' : 'validation.error.required';
}
